import './professionals.component.scss'

import $ from 'jquery'

import 'swiper/css'
import 'swiper/css/autoplay'
import Swiper, { Navigation } from 'swiper'
Swiper.use([Navigation])

$(document).ready(function () {
  $('.professionals').each(function () {
    const general = $(this);
    const settings = {
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: {
        prevEl: general.find('.professionals__slider-prev')[0],
        nextEl: general.find('.professionals__slider-next')[0]
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        600: {
          slidesPerView: 1
        }
      }
    };
    const slider = new Swiper(general.find('.professionals__slider')[0], { ...settings, init: false });
    general.find('[data-toggle]').click(function () {
      if ($(this).data('toggle')) {
        general.removeClass('professionals--active');
        general.find('.professionals__slider-wrapper').slideUp(250);
        $(this).data('toggle', false);
      } else {
        general.addClass('professionals--active');
        general.find('.professionals__slider-wrapper').slideDown(250);
        const scrollTo = general.find('.professionals__slider-wrapper').offset().top - $(window).height() / 2;
        $('html, body').animate({ scrollTop: scrollTo }, 250);
        slider.init(settings);
        $(this).data('toggle', true);
        $(this).hide();
      }
    });
  });
});